<ciao-modal
  #userModal
  [title]="modalTitle$ | async"
  [preventBackdropClosing]="true"
  windowClass="user-modal-narrow"
>
  <div modalBody>
    <ciao-user-details-form
      #currentForm
      [personId]="id"
      class="imSpecial"
    ></ciao-user-details-form>
  </div>
  <span modalFooter class="imSpecial" id="user-modal-footer">
    <div class="d-flex justify-content-between w-100">
      @if (canDelete$ | async) {
      <button
        class="btn-action-light center delete-user-btn"
        (click)="confirmDelete()"
        [disabled]="isSaving || isDeleting"
        data-cy="delete-user-button"
      >
        Delete User
      </button>
      }
      <button
        class="btn-action-solid center ms-auto"
        (click)="saveData()"
        [disabled]="!formIsValid || isSaving"
      >
        {{ saveButtonMessage }}
      </button>
    </div>
  </span>
</ciao-modal>

<ciao-modal #deleteModal title="Delete User">
  <div modalBody>
    <h2>Are you sure you want to delete {{ personDisplayName$ | async }}?</h2>
    <p>This action <strong>cannot be undone.</strong></p>
  </div>
  <span modalFooter>
    <div class="d-flex">
      <button
        class="btn-action-light center"
        (click)="deleteModal.dismiss('cancel')"
        [disabled]="isDeleting"
      >
        Cancel
      </button>
      <button
        class="btn-action-solid center"
        (click)="deleteData()"
        [disabled]="isDeleting"
        data-cy="confirm-delete-user-button"
      >
        {{ isDeleting ? "Deleting..." : "Confirm Delete" }}
      </button>
    </div>
  </span>
</ciao-modal>
